import styled from '@emotion/styled';
import { colors, spacing, typography } from '../../../themes/stena-recycling';

export const CheckboxContainer = styled.div<{ fullWidth?: boolean }>`
  display: ${({ fullWidth }) => (fullWidth ? 'flex' : 'inline-flex')};
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  flex-direction: row;
  cursor: pointer;
`;

export const HoverCheckboxWrapper = styled.div<{ isHover?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  opacity: ${({ isHover }) => (isHover ? 1 : 0)};
  justify-content: center;
  cursor: pointer;

  .checkbox-container:hover & {
    opacity: 1;
  }
`;

export const StyledCheckbox = styled.div<{
  disabled?: boolean;
  isChecked: boolean;
  isHover: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 2px solid
    ${({ disabled, isChecked, isHover }) => {
      if (disabled) return colors.monochrome.grey40;
      if (isChecked || isHover) return colors.base.black;

      return colors.primary.grey;
    }};
  padding: 0;
  width: ${spacing.small};
  height: ${spacing.small};
  background: ${colors.base.white};
  border-radius: 3px;

  :disabled {
    cursor: unset;
  }

  :hover:not(:disabled) {
    border-color: ${colors.base.black};
  }
`;

export const LabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${spacing.xmsmall};
  min-width: 0;
`;
export const Label = styled.label<{ multilineLabel?: boolean }>`
  cursor: pointer;
  ${typography.other.inputLabel}

  ${({ multilineLabel = false }) =>
    !multilineLabel && `text-overflow: ellipsis; overflow-x: hidden; white-space: nowrap;`}
`;
export const LabelDiv = styled.div`
  ${typography.other.inputLabel}
`;

export const Description = styled.span`
  ${typography.body.medium}
  color: ${colors.primary.grey};
`;

export const StyledInput = styled.input`
  // Hide the input element without hiding it from screen readers
  display: block;
  width: 0;
  height: 0;
  margin: 0;
  scale: 0;
`;

export const InputErrorMessage = styled.div`
  height: 22px;
  ${typography.body.medium}
  color: ${colors.alerts.error};
  margin-top: ${spacing.tiny};
`;
